import _ from 'lodash';
import { AbstractControl, Validators } from '@angular/forms';
import * as moment from 'moment';

import { CampaignSchema } from './campaign';
import { AMOUNT_LIMIT } from 'app/virtual-event/virtual-event.enums';

export const TicketingGuestSchema = {
    'fields': [{
        'field': 'id',
        'value': '',
        'validators': []
    },{
        'field': 'infoName',
        'value': '',
        'validators': [Validators.required]
    }, {
        'field': 'infoDesc',
        'value': '',
        'validators': [],
    }, {
        'field': 'infoOptions',
        'value': [],
        'validators': []
    }, {
        'field': 'infoType',
        'value': null,
        'validators': [Validators.required]
    }, {
        'field': 'optional',
        'value': true,
        'validators': [],
    }, {
        'field': 'toBeAddedBy',
        'value': false,
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value ? 0: 1;
            },
            'setter': (data, value) => {
                switch(value) {
                    case 0:
                    case true:
                        return true;
                    case 1:
                    case false:
                        return false;
                }
                return false;
            }
        }
    }]
}

export const TicketComboSchema = {
    'fields': [{
        'field': 'campaignId',
        'value': null,
        'validators': [Validators.required]
    },{
        'field': 'campaignIntId',
        'value': null,
        'validators': [Validators.required]
    }, {
        'field': 'optionId',
        'value': null,
        'validators': [Validators.required],
    }, {
        'field': 'count',
        'value': 0,
        'validators': [Validators.required, Validators.min(1)]
    },{
        'field': 'enforceInventory',
        'value': false,
        'validators': []
    }]
}

export const TicketingPresetOptionSchema = {
    'arrays': [{
        'array': 'ticketCombo',
        'schema': TicketComboSchema,
        'value': [],
        'validators': [],
    }],
    'fields': [{
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    }, {
        'field': 'imageUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    }, {
        'field': 'thumbnailFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'thumbnailDataUrl',
        'value': '/images/blank_1x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.thumbnailUrl === '' ? '/images/blank_1x1.png': data.thumbnailUrl
            }
        }
    }, {
        'field': 'thumbnailUrl',
        'value': '/images/blank_1x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_1x1.png': value
            }
        }
    }, {
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'allowedQuantity',
        'value': 5,
        'validators': [Validators.required, Validators.min(1)],
        'options': {
            'getter': (control) => parseInt(control.value),
            'validators': (data, value) => {
                const minQuantity = _.isNull(data.minQuantity) ? 0: data.minQuantity;
                return minQuantity > 0 ?
                    [Validators.required, Validators.min(minQuantity),Validators.max(1000)]:
                    [Validators.required, Validators.min(1), Validators.max(1000)];
            }
        }
    }, {
        'field': 'amount',
        'value': 0,
        'validators': [Validators.required, Validators.min(0), Validators.max(400000)],
        'options': {
            'getter': (control) => parseFloat(control.value),
            'validators': (data, value) => {
                return value === 0 ?
                    [Validators.required, Validators.min(0), Validators.max(400000)]:
                    [Validators.required, Validators.min(1), Validators.max(400000)];
            }
        }
    }, {
        'field': 'groupTicket',
        'value': false,
        'validators': []
    }, {
        'field': 'inventory',
        'value': 0,
        'validators': [],
        'options': {
            'getter': (control) => parseInt(control.value)
        }
    }, {
        'field': 'enforceInventory',
        'value': false,
        'validators': [],
        'options': {
            'getter': (control) => control.value,
            'setter': (data, value) => value
        }
    }, {
        'field': 'hideInventory',
        'value': true,
        'validators': [],
        'options': {
            'getter': (control) => control.value,
            'setter': (data, value) => {
                return data.enforceInventory ? value: true;
            }
        }
    }, {
        'field': 'dontCountForGlobalInventory',
        'value': false,
        'validators': [],
        'options': {
            'getter': (control) => control.value,
            'setter': (data, value) => {
                return data.dontCountForGlobalInventory ? value: false;
            }
        }
    }, {
        'field': 'inviteEnabled',
        'value': false,
        'validators': []
    }, {
        'field': 'noGuestRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'dontSendTickets',
        'value': false,
        'validators': []
    }, {
        'field': 'minQuantity',
        'value': 1,
        'validators': [Validators.required, Validators.min(1)],
        'options': {
            'getter': (control) => parseInt(control.value),
            'validators': (data, value) => {
                const allowedQuantity = _.isNull(data.allowedQuantity) ? 0: data.allowedQuantity;
                return allowedQuantity > 0 ?
                    [Validators.required, Validators.min(1), Validators.max(allowedQuantity)]:
                    [Validators.required, Validators.min(1), Validators.max(1000)];
            }
        }
    }, {
        'field': 'multiplier',
        'value': 0,
        'validators': [],
        'options': {
            'getter': (control) => parseInt(control.value),
            'validators': (data, value) => data.groupTicket ? [Validators.required, Validators.min(2)]: []
        }
    }, {
        'field': 'name',
        'value': '',
        'validators': [Validators.required, Validators.maxLength(512)]
    }, {
        'field': 'desc',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'summary',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'valueProvided',
        'value': 0,
        'validators': [Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => {
                return control.value;
            }
        }
    }, {
        'field': 'enableTicketCombo',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                if(data.ticketCombo){
                    return data.ticketCombo.length > 0 ? true: false;
                }
                return
                
            }
        }
    }, {
      'field': 'additionalInfoRequired',
      'type': 'boolean',
      'value': false,
      'validators': [],
      'options': {
            'setter': (data, value) => {
                if(value === true) {
                    return true;
                }
                return _.isEmpty(data.additionalInfoDesc) ? false: true
            }
      }
    }, {
      'field': 'additionalInfoDetail',
      'value': '',
      'validators': [],
      'options': {
        'setter': (data, value) => value || ''
      }
    }, {
      'field': 'additionalInfoDesc',
      'value': '',
      'validators': [],
      'options': {
        'setter': (data, value) => value || '',
        'validators': (data) => {
            return data.additionalInfoRequired ? [Validators.required] : [];
        }
      }
    }, {
      'field': 'additionalInfoSelectRequired',
      'type': 'boolean',
      'value': false,
      'validators': [],
      'options': {
        'setter': (data, value) => {
            if(value === true) {
                return true;
            }
            return _.isEmpty(data.additionalInfoSelectDesc) ? false: true
        }
      }
    }, {
      'field': 'additionalInfoSelect',
      'value': [],
      'validators': [],
      'options': {
        'setter': (data, value) => value || [],
        'validators': (data) => {
            return data.additionalInfoSelectRequired ? [Validators.required] : [];
        }
      }
    }, {
      'field': 'additionalInfoSelectDesc',
      'value': '',
      'validators': [],
      'options': {
        'validators': (data) => {
            return data.additionalInfoSelectRequired ? [Validators.required] : [];
        }
      }
    }]
};

export const TicketingBasketRaffleItemSchema = {
    'fields': [{
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.image === '' ? '/images/blank_2x1.png': data.image
            }
        }
    }, {
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'desc',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'image',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    }, {
        'field': 'name',
        'value': '',
        'validators': [Validators.required, Validators.maxLength(512)]
    }]
};

const clonedCampaignSchema = _.cloneDeep(CampaignSchema);
clonedCampaignSchema.fields.push({
    'field': 'type',
    'value': 6,
    'validators': [Validators.required]
})
clonedCampaignSchema.groups = [{
    'group': 'campaignTypeData',
    'arrays': [{
        'array': 'guestProfile',
        'schema': TicketingGuestSchema,
        'value': [],
        'validators': [],
        'options': {
            'validators': (data) => _.get(data, 'guestRequired', false) ? []: []
        }
    }, {
        'array': 'presetOptions',
        'schema': TicketingPresetOptionSchema,
        'value': [],
        'validators': []
    }],
    'fields': [{
        'field': 'endTime',
        'value': null,
        'validators': [],
        'options': {
            'getter': (control) => _.isNull(control.value) ? '': control.value,
        }
    }, {
        'field': 'eventDates',
        'value': [],
        'validators': []
    }, {
        'field': 'eventDetailLink',
        'value': '',
        'validators': [(control: AbstractControl) => {
            if(control.value === "") {
                return null;
            }

            let url = true;
            try {
              const urlString = control.value.substr(0,4) === "www." ? `https://${control.value}`: control.value;
              new URL(urlString)
            } catch {
              url = false;
            }

            return url ? null : { url: true };
        }]
    }, {
        'field': 'guestRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'noGuestRequiredBeforePayment',
        'value': false,
        'validators': []
    }, {
        'field': 'guestAddCuttoffDate',
        'type': 'number',
        'value': 0,
        'validators': [Validators.required, Validators.nullValidator]
    }, {
        'field': 'gridView',
        'value': false,
        'validators': []
    }, {
        'field': 'showTicketHolders',
        'value': false,
        'validators': []
    }, {
        'field': 'privateTicket',
        'value': false,
        'validators': []
    }, {
        'field': 'saveCardEnabled',
        'value': false,
        'validators': []
    },
    {
        'field': 'enforceCampaignInventory',
        'value': false,
        'validators': []
    }, {
        'field': 'campaignInventory',
        'value': 0,
        'validators': [],
        'options': {
            'setter': (data, value) => {
                return data.enforceCampaignInventory ? value: 0;
            },
            'validators': (data) => data.enforceCampaignInventory ? [Validators.min(1)]: []
        }
    }, {
        'field': 'hideCampaignInventory',
        'value': false,
        'validators': [],
        'options': {
            'getter': (control) => control.value,
            'setter': (data, value) => {
                return data.enforceCampaignInventory ? value: false;
            }
        }
    }, {
        'field': 'multiSelect',
        'value': true,
        'validators': []
    }, {
        'field': 'sendCheckinEmail',
        'value': false,
        'validators': []
    }, {
        'field': 'sendCheckinText',
        'value': false,
        'validators': []
    },  {
        'field': 'isTicketForVirtualEvent',
        'value':  null,
        'validators': [],
        'options': {
            'virtual': false,
            'setter': (data, value) => value
        }
    },  {
        'field': 'isTicketForInPersonEvent',
        'value':  null,
        'validators': [],
        'options': {
            'virtual': false,
            'setter': (data, value) => value
        }
    }, {
        'field': 'isRaffleTicket',
        'value': false,
        'validators': [],
        'options': {
            'getter': (control) => control.value,
            'setter': (data, value) => {
                return data.basketRaffle ? true : value;
            }
        }
    },  {
        'field': 'basketRaffle',
        'value': false,
        'validators': []
    },  {
        'field': 'postActivityFormUrlRequired',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => _.isEmpty(data.postActivityFormUrl) ? false: true
        }
    }, {
        'field': 'postActivityFormUrl',
        'value': '',
        'validators': [],
        'options': {
            'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required, Validators.pattern(/^(?:(?:http(s)?):\/\/(www\.)?)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]$/i)]
        }
    }, {
        'field': 'sendTickets',
        'value': false,
        'validators': []
    }, {
        'field': 'startTime',
        'value': null,
        'validators': [],
        'options': {
            'getter': (control) => _.isNull(control.value) ? '': control.value,
        }
    }, {
        'field': 'startDateTimeGmtUnix',
        'value': 0,
        'validators': [Validators.required],
        'options': {
            'getter': (control) => _.isNull(control.value) ? 0: control.value,
        }
    }, {
        'field': 'duration',
        'value': 60,
        'validators': [Validators.required, Validators.min(1), Validators.max(1440)],
        'options': {
            'setter': (data, value) => {
                if(_.isNumber(value)) {
                    return value < 1 ? 60: value;
                }
                return 60;
            }
        }
    }, {
        'field': 'timeZoneList',
        'value': () => {
            const timestamp = new Date().getTime() / 1000;
            const zones = moment.tz.names();
            return _.map(zones, (name, index) => {
                const label = `(GMT ${moment.tz(timestamp, name).format('Z')}) ${name} - ${moment.tz(timestamp, name).format('z')}`;
                return { index, label, value: name };
            });
        },
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => _.isFunction(value) ? value(): value
        }
    }, {
        'field': 'timeZone',
        'value': () => (new Date()).getTimezoneOffset()*-60,
        'validators': [Validators.required],
        'options': {
            'setter': (data, value) => _.isFunction(value) ? value(): value
        }
    }, {
        'field': 'timeZoneAbbr',
        'value': () => (new Date()).toLocaleTimeString('en-us',{ timeZoneName:'short' }).split(' ')[2],
        'validators': [],
        'options': {
            'setter': (data, value) => _.isFunction(value) ? value(): value
        }
    }, {
        'field': 'linkedEventId',
        'value': null,
        'validators': []
    }, {
        'field': 'linkedVirtualEventID',
        'value': null,
        'validators': []
    }, {
        'field': 'addOnDonationCampaignRequired',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => _.isEmpty(data.addOnDonationCampaignId) ? false: true
        }
    }, {
        'field': 'addOnDonationCampaignId',
        'value': null,
        'validators': [],
        'options': {
            'virtual': false,
            'getter': (control) => {
                return _.isEmpty(control.value) ? "": control.value;
            }
        }
    }],
    'groups': [{
        'group': 'eventVenue',
        'fields': [{
            'field': 'formatted_address',
            'value': '',
            'validators': []
        }, {
            'field': 'name',
            'value': '',
            'validators': []
        }, {
            'field': 'address',
            'value': {},
            'validators': [],
            'options': {
                'getter': (control, form) => {
                    const { value: unitNum } = form.get('unitNum');
                    if(control.value instanceof Object) {
                        return { ...control.value, unitNum: unitNum };
                    }
                    return control.value;
                }
            }
        }, {
            'field': 'unitNum',
            'value': '',
            'validators': [],
            'options': {
                'virtual': true,
                'setter': (data, value) => {
                    const address = data ? data.address: null;
                    if(address instanceof Object) {
                        return data.address.unitNum;
                    }
                    return value;
                }
            }
        }]
    }, {
        'group': 'timeZoneData',
        'fields': [{
            'field': 'name',
            'value': () => moment.tz.guess(),
            'validators': [],
            'options': {
                'setter': (data, value) => _.isFunction(value) ? value(): value
            }
        }, {
            'field': 'abbr',
            'value': () => {
                const guess = moment.tz.guess();
                const zone = moment.tz.zone(guess);
                const timestamp = (new Date()).getTime();
                return zone.abbr(timestamp);
            },
            'validators': [],
            'options': {
                'setter': (data, value) => _.isFunction(value) ? value(): value
            }
        }, {
            'field': 'offset',
            'value': () => {
                const guess = moment.tz.guess();
                const zone = moment.tz.zone(guess);
                const timestamp = (new Date()).getTime();
                const abbr = zone.abbr(timestamp);
                const index = _.findIndex(zone.abbrs, (value) => _.isEqual(value, abbr));
                return zone.offsets[index] * -60;
            },
            'validators': [],
            'options': {
                'setter': (data, value) => _.isFunction(value) ? value(): value
            }
        }]
    }]
}];
export const TicketingSchema = clonedCampaignSchema;
